import {
  Document as PDFDocument,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import React from 'react';

import seekLogo from '../../../../assets/seek_logo.png';
import { breakLongJobTitle } from '../../../../utils/QRCodeUtils';
import { pageStyles } from '../styles';

// @ts-ignore
const styles = StyleSheet.create({ ...pageStyles });

const QRCodePdf = ({
  document,
  qrCodeId,
  jobTitle,
  jobPostedDate,
}: {
  document: Document;
  jobTitle: string;
  qrCodeId: string;
  jobPostedDate: string;
}) => {
  const dataUrl = (
    document.getElementById(qrCodeId) as HTMLCanvasElement
  ).toDataURL('image/png', 1.0);
  const { firstPartTitle, secondPartTitle } = breakLongJobTitle(jobTitle);

  const setPrimaryHeadingStyle = () =>
    Boolean(secondPartTitle)
      ? { ...styles.jobTitleHeading, marginBottom: 10 }
      : styles.jobTitleHeading;

  return (
    <PDFDocument>
      <Page size="A4" style={styles.componentWrapper}>
        <View style={styles.componentWrapper}>
          <Text style={styles.primaryHeading}>We’re hiring:</Text>
          <Text style={setPrimaryHeadingStyle()}>{firstPartTitle}</Text>
          {Boolean(secondPartTitle) && (
            <Text style={styles.jobTitleHeading}>{secondPartTitle}</Text>
          )}
          <Text style={styles.secondaryHeading}>
            Scan the code to apply on SEEK
          </Text>
          <Image src={dataUrl} style={styles.QRImage} />
          <Text style={styles.jobPostedDate}>
            This job ad was posted on {jobPostedDate}
          </Text>
          <View style={styles.bannerView} fixed>
            <Image src={seekLogo} style={styles.logo_pdf} />
          </View>
        </View>
      </Page>
    </PDFDocument>
  );
};

export default QRCodePdf;
